<template>
  <div>
    <div v-if ="this.$i18n.locale == 'en'" class="title">Historical Profit and Loss Calculator</div>
    <div v-if ="this.$i18n.locale == 'tr'" class="title">Tarihsel Kar Zarar Hesaplayıcı</div>
    <div class="date-input" >
      <span>
        <label v-if ="this.$i18n.locale == 'tr'" for="start-date">Başlangıç Tarihi:</label>
        <label v-if ="this.$i18n.locale == 'en'" for="start-date">Start Date:</label>
        <input type="date" id="start-date" v-model="startDate"/>
      </span>
      <span>
        <label v-if ="this.$i18n.locale == 'tr'" for="end-date">Bitiş Tarihi:</label>
        <label v-if ="this.$i18n.locale == 'en'" for="end-date">End Date:</label>
        <input type="date" id="end-date" v-model="endDate"/></span>
    </div>

    <div class="form-group">
      <span class="input-box">
        <label v-if="this.$i18n.locale=='tr'" for="input1" >Adet</label>
        <label v-if="this.$i18n.locale=='en'" for = "input1">Piece</label>
        <input type="number" id="input1" style="width:100px"  v-model="amountSelected" />
      </span>

      <span>
        <div id="symbols" class="control">           
              <select id="select1" class="select" v-model="selected" style="margin-left:10px">  
                <option v-if ="this.$i18n.locale == 'en'" hidden value="default">Select Symbol</option>         
                <option v-if ="this.$i18n.locale == 'tr'" hidden value="default">Sembol Seçiniz</option>  
                <option value="XU100">XU100</option>
                <option value="XUTUM">XUTUM</option>
                <option value="XYUZO">XYUZO</option>
                <option value="X100S">X100S</option>
                <option value="X100C">X100C</option>
                <option value="XK030EA">XK030EA</option>
                <option value="XYLDZ">XYLDZ</option>
                <option value="XKTUM">XKTUM</option>
                <option value="XK100">XK100</option>
                <option value="XK050">XK050</option>
                <option value="XK030">XK030</option>
                <option value="XSRDK">XSRDK</option>
                <option value="XKURY">XKURY</option>
                <option value="XUSRD">XUSRD</option>
                <option value="XSD25">XSD25</option>
                <option value="XUHIZ">XUHIZ</option>
                <option value="XTCRT">XTCRT</option>
                <option value="XSIST">XSIST</option>     
              </select>      
            </div> 

      </span>

      <button v-if ="this.$i18n.locale == 'en'" class="buttonCalc" @click="calculate">Calculate</button>
      <button v-if ="this.$i18n.locale == 'tr'" class="buttonCalc" @click="calculate">Hesapla</button>
    </div>
    <label>{{ calculationResult }}</label>
    <div class="form-group">      
      <span class="input-box">
        <label v-if="this.$i18n.locale=='tr'" for="input1">1. tarihteki fiyat</label>
        <label v-if="this.$i18n.locale=='en'" for ="input1">Price on date 1</label>
        <input type="text" readonly id="input1" :value="KZData['Close1']" />
      </span>
      <span class="input-box">
        <label v-if="this.$i18n.locale=='tr'" for="input1">2. tarihteki fiyat</label>
        <label v-if="this.$i18n.locale=='en'" for="input1">Price on date 2</label>
         <input type="text" readonly id="input1" :value="KZData['Close2']" />
      </span>
    </div>
    <div class="form-group"> 
      <span class="input-box">
        <label v-if="this.$i18n.locale=='tr'" for="input1">Kar Zarar</label>
        <label v-if="this.$i18n.locale=='en'" for="inpput1">Profit and Loss</label>
         <input type="text" readonly id="input1" :value="KZData['KZ']" />
      </span>
      <span class="input-box">
        <label v-if="this.$i18n.locale=='tr'" for="input1">Kar Zarar Yüzdesi</label>
        <label v-if="this.$i18n.locale=='en'" for="input1">Profit Loss Percentage</label>
         <input type="text" readonly id="input1" :value="KZData['KZPercent']" />
      </span>
    </div>

  </div>

</template>
<style>
.date-input {
  display: flex;
  align-items: center;  
  margin-bottom: 40px;
  gap: 10px;
}
.title {
  display: flex;
  text-align: right;
  font-size: 20px !important;
  margin-bottom: 40px;
}
.date-input label {
  margin-right: 5px;
}
.buttonCalc{
  margin-left: 8px!important;
}
#select1{
  height: 24px!important;
}
.form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: end;
  margin-bottom: 50px;
}

.input-box label {
  display: block;  
}
.buttonCalc {
  display: block;
  width: 120px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);  
  margin-top: 20px;    
  grid-gap: 10px;
  grid-template-columns: 380px;
}
.grid-item {
  border: 1px solid #ccc;
  padding: 10px;
}
</style>
<script>
import axios from "axios";



export default {

  data() {
    return {
      startDate: "2023-06-21",
      endDate: "2023-06-23",
      input1: "default",     
      selected:"default",
      amountSelected:1,   
      calculationResult: "",
      gridValues: [],
      data: [],
      KZData:{}
    };
  },
   mounted: function() {
    this.fetchData();
   
  },
  methods: {

    calculate() {
        this.fetchData();  
        console.log(this.selected);     
    },
   fetchData: function() {
      axios
        .get(
          process.env.VUE_APP_PROXY +
          "cmd=GetCalculateKZ?Sembol=" +     
           this.selected +      
            "?Tarih1=" +
            this.startDate.replace("-","").replace("-","")+
            "?Tarih2="+
            this.endDate.replace("-","").replace("-","")+
            "?adet="+
             this.amountSelected+
            "?lang=" +
            this.$i18n.locale,      
          { responseType: "json"}
        )
        .then(response => this.send(response));
    },
    send: function(response) {
      let data = response.data; 
      this.KZData=data;       
    },

  },
};
</script>
